module.exports = __webpack_public_path__ + "img/image (0).732debb3.png";